import { Card } from '@/components/ui/Card';
import { LoadingState, EmptyState } from '@/components/ui/States';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/Table';
import { ScheduleBadge } from './ScheduleBadge';
import { useScheduleRegister } from './useScheduleRegister';

export default function RegisterTab() {
  const { data: rows, isLoading } = useScheduleRegister();

  return (
    <Card>
      <div className="mb-1.5 text-sm font-semibold">Schedule H1 / X dispensing register</div>
      <div className="mb-3.5 text-xs text-ink-muted">
        Statutory log for regulatory inspection — every Schedule H1/X sale, with prescriber and patient identity captured at the time of dispensing.
      </div>
      {isLoading ? (
        <LoadingState />
      ) : (
        <div>
          <Table className="min-w-[900px]">
            <TableHeader>
              <TableRow>{['Date', 'Medicine', 'Sched.', 'Batch', 'Qty', 'Patient', 'Prescriber', 'Reg. no.', 'Dispensed by'].map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow>
            </TableHeader>
            <TableBody>
              {(rows ?? []).map((r) => (
                <TableRow key={r.id}>
                  <TableCell className="text-xs">{new Date(r.dispensed_at).toLocaleString('en-IN')}</TableCell>
                  <TableCell>{r.generic_name} {r.strength}</TableCell>
                  <TableCell><ScheduleBadge schedule={r.schedule} /></TableCell>
                  <TableCell className="font-mono text-xs">{r.batch_number}</TableCell>
                  <TableCell>{r.quantity}</TableCell>
                  <TableCell className="text-xs">{r.patient_name} ({r.patient_uhid})</TableCell>
                  <TableCell className="text-xs">{r.prescriber_name}</TableCell>
                  <TableCell className="text-xs">{r.prescriber_reg_no || '—'}</TableCell>
                  <TableCell className="text-xs">{r.dispensed_by}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {(rows ?? []).length === 0 && <EmptyState label="No Schedule H1/X sales recorded yet" />}
        </div>
      )}
    </Card>
  );
}
